import FormattedMessage from 'I18n/components/FormattedMessage';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import { useCallback } from 'react';
import getPropertyValue from '../../../dataAccessHelpers/getPropertyValue';
import { useAuthedUser } from '../../../hooks/useAuthedUser';
import { useSendAuthorizationCopyMutation } from '../../../hooks/useSendAuthorizationCopyMutation';
import { usageTracker } from '../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function showSuccessAlert() {
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.successAlert"
    }),
    type: 'success'
  });
}
function showErrorAlert() {
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.errorAlert"
    }),
    type: 'danger'
  });
}
function SendAuthorizationCopyModal({
  properties,
  onClose
}) {
  const user = useAuthedUser();
  const [sendAuthorizationCopy, {
    loading
  }] = useSendAuthorizationCopyMutation({
    invoiceId: parseInt(getPropertyValue(properties, 'hs_platform_invoice_id'), 10),
    onError: showErrorAlert,
    onSuccess() {
      showSuccessAlert();
      usageTracker.track('paymentCRMSidebarUsage', {
        action: 'sendAuthorizationCopyModalSubmitClicked'
      });
      onClose();
    }
  });
  const handleSendAuthorizationCopy = useCallback(() => {
    /* eslint-disable-next-line @typescript-eslint/no-floating-promises */
    sendAuthorizationCopy();
  }, [sendAuthorizationCopy]);
  const handleSendAuthorizationCopyModalCancel = useCallback(() => {
    usageTracker.track('paymentCRMSidebarInteraction', {
      action: 'sendAuthorizationCopyModalCancelClicked'
    });
    onClose();
  }, [onClose]);
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 600,
    "data-test-id": "send-authorization-copy-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      className: "text-left",
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.title"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      className: "text-left",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.body",
        options: {
          email: user.email
        }
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UILoadingButton, {
        "data-test-id": "send-authorization-copy-modal-send-button",
        use: "primary",
        onClick: handleSendAuthorizationCopy,
        loading: loading,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.send"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "send-authorization-copy-modal-cancel-button",
        onClick: handleSendAuthorizationCopyModalCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.modal.cancel"
        })
      })]
    })]
  });
}
export default SendAuthorizationCopyModal;